import { observer } from 'mobx-react-lite'
import React, { useContext, useState } from 'react'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import Input from '../../../../../FormComponents/Input'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'
import { currencyFormat, currencyUnit } from '../../../../../../utils/Helper'
import CurrencyField from '../../../../../FormComponents/CurrencyField'
import Switch from '../../../../../FormComponents/Switch'

export default observer(function OverviewPaid({ values, setFieldValue, handleChange, handleBlur }) {
  const [open, setOpen] = useState(true)
  const { campaign } = useContext(CampaignContext)

  return (
    <div className="mb-8">
      <div className="flex justify-between mt-8">
        <p className="font-bold">Overview - Paid</p>
        <button type="button" onClick={() => setOpen(!open)}>{open ? <ChevronUp /> : <ChevronDown /> }</button>
      </div>
      <div className={`${open ? 'h-[650px]' : 'h-0 overflow-hidden'} transition-all duration-300`}>
        <table className="w-full border-1 border-gray-100 rounded-lg">
          <tbody>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Total Impressions - Paid</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <CurrencyField
                  topMargin=''
                  name='paid_impressions'
                  thousandSeparator='.'
                  decimalSeparator=','
                  decimalScale={0}
                  valueIsNumericString={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.paid_impressions}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Total Reach - Paid</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <CurrencyField
                  topMargin=''
                  name='paid_reach'
                  thousandSeparator='.'
                  decimalSeparator=','
                  decimalScale={0}
                  valueIsNumericString={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.paid_reach}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Ad Budget</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <CurrencyField
                  topMargin=''
                  name='paid_spend_overview'
                  addon={currencyUnit(campaign.currency)}
                  thousandSeparator='.'
                  decimalSeparator=','
                  decimalScale={2}
                  fixedDecimalScale={true}
                  valueIsNumericString={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.paid_spend_overview}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Clicks - Paid</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <CurrencyField
                  topMargin=''
                  name='paid_clicks'
                  thousandSeparator='.'
                  decimalSeparator=','
                  decimalScale={0}
                  valueIsNumericString={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.paid_clicks}
                />
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Cost per Click (CPC) - Paid</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <span className="text-sm bg-gray-100 p-2 rounded-md p-2">
                  {
                    values.paid_clicks && values.paid_spend_overview ?
                      currencyFormat((values.paid_spend_overview / values.paid_clicks).toFixed(2), campaign.currency)
                    :
                      '-'
                  }
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Cost per Thousand (CPM) - Paid</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <span className="text-sm bg-gray-100 p-2 rounded-md p-2">
                  {
                    values.paid_impressions && values.paid_spend_overview ?
                      currencyFormat(((values.paid_spend_overview / values.paid_impressions) * 1000).toFixed(2), campaign.currency)
                    :
                      '-'
                  }
                </span>
              </td>
            </tr>
            <tr>
              <td className={`text-sm font-bold p-4 border-1 border-gray-100 w-1/3 ${!values.paid_roi_visible ? 'opacity-30' : ''} relative`}>
                <div className="absolute top-1 left-1 cursor-pointer">
                  <Switch name="paid_roi_visible" value={values.paid_roi_visible} onChange={({ target: { checked }}) => setFieldValue('paid_roi_visible', checked, true)} eyeSwitch />
                </div>
                <span>Revenue Generated - Paid</span>
              </td>
              <td className={`p-4 border-1 border-gray-100 ${!values.paid_roi_visible ? 'opacity-30' : ''}`} colSpan="2">
                <CurrencyField
                  topMargin=''
                  name='paid_revenue_generated'
                  addon={currencyUnit(campaign.currency)}
                  thousandSeparator='.'
                  decimalSeparator=','
                  decimalScale={2}
                  fixedDecimalScale={true}
                  valueIsNumericString={true}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.paid_revenue_generated}
                  disabled={!values.paid_roi_visible}
                />
              </td>
            </tr>
            <tr>
              <td className={`text-sm font-bold p-4 border-1 border-gray-100 w-1/3 ${!values.paid_roi_visible ? 'opacity-30' : ''}`}>Return of Investment (ROI) - Paid</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <span className={`text-sm bg-gray-100 p-2 rounded-md p-2 ${!values.paid_roi_visible ? 'opacity-30' : ''}`}>
                  {
                    values.paid_roi_visible && values.paid_revenue_generated && values.paid_spend_overview ?
                      currencyFormat(((values.paid_revenue_generated / values.paid_spend_overview) * 100).toFixed(2), campaign.currency)
                    :
                      '-'
                  }
                </span>
              </td>
            </tr>
            <tr>
              <td className="text-sm font-bold p-4 border-1 border-gray-100 w-1/3">Comment</td>
              <td className="p-4 border-1 border-gray-100" colSpan="2">
                <Input
                  topMargin=''
                  name='paid_comment'
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.paid_comment}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
})